import React, { useState } from 'react';
import { uploadImageOnAWS } from '../../aws/Service';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/common.service';

const UploadMedia = () => {
    const [file, setFile] = useState(null);
    const [folder, setFolder] = useState(null);

    const onSubmit = async () => {
        try {
            const image = await uploadImageOnAWS(file, folder);
            console.log('image :', image);
            if (image) {
                TOAST_SUCCESS("Success");
            } else {
                TOAST_ERROR("Error");
            }
        } catch (error) {
            TOAST_ERROR(error);
        }
    };

    return (
        <>
            <input type="file" onChange={(e) => setFile(e.target.files[0])} />
            <input type="text" onChange={(e) => setFolder(e.target.value)} />
            <button type="button" onClick={onSubmit}>Submit</button>
        </>
    );
};

export default UploadMedia;